import { RefObject, useEffect } from "react";

export function useClickOutside<T extends HTMLElement>(
    ref: RefObject<T | null>,
    active: boolean,
    onClose: () => void,
) {
    useEffect(() => {
        if (!active) return;
        const handleMouseDown = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                onClose();
            }
        };
        // Clicks inside an iframe don't bubble to the parent document, but they
        // do steal focus from the parent window, firing `blur` — use that as a
        // fallback so dropdowns close when the user clicks iframe content.
        const handleBlur = () => onClose();
        document.addEventListener("mousedown", handleMouseDown);
        window.addEventListener("blur", handleBlur);
        return () => {
            document.removeEventListener("mousedown", handleMouseDown);
            window.removeEventListener("blur", handleBlur);
        };
    }, [active, ref, onClose]);
}
